import { FormControlLabel, Switch } from "@material-ui/core";
import { FC, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Loader } from "../../../../components/loader";
import { BillingDTO } from "../../../../store/billing/models/dto";
import { Billing } from "../../../../store/billing/reducer";
import { useFetchable } from "../../../../store/common/fetchable";
import { Details, SwitchGroup } from "./common";
import { CardProps, CardWrapper, Value } from "./default";

export const AMLCard: FC<CardProps> = (props) => {
  const pricing = useFetchable(Billing.pricing);
  return (
    <Loader data={[pricing]}>
      {([loadedPricing]) => <InnerCard {...props} pricing={loadedPricing} />}
    </Loader>
  );
};

const InnerCard: FC<
  CardProps & {
    pricing: BillingDTO.Responses.GetPricing.T;
  }
> = (props) => {
  const [isOngoing, setIsOngoing] = useState(false);

  const { t } = useTranslation("common");

  // Find aml/ongoing prices
  const ongoingPrice =
    props.pricing.featureDetails.find((x) => x.featureName === "ONGOING_AML")
      ?.originalPrice || 0;

  // Sum total
  const totalPrice = props.originalPrice + (isOngoing ? ongoingPrice : 0);

  const availableCalls = useMemo(
    () => Math.floor(props.credits / (totalPrice * props.discount)),
    [props.credits, totalPrice, props.discount]
  );

  return (
    <CardWrapper {...props} originalPrice={totalPrice}>
      <Details>
        <SwitchGroup>
          <FormControlLabel
            control={
              <Switch
                checked={isOngoing}
                onChange={() => setIsOngoing(!isOngoing)}
                color="primary"
              />
            }
            label={t("ongoing-checks", { context: "title", count: 2 })}
          />
        </SwitchGroup>
        <Value>{availableCalls}</Value>
      </Details>
    </CardWrapper>
  );
};
